var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\uADF8\\uB8F9_7985",
    "data-name": "\\uADF8\\uB8F9 7985",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.965,
    height: 21,
    viewBox: "0 0 19.965 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12639",
    "data-name": "\\uD328\\uC2A4 12639",
    d: "M208.653,21h-11.34A4.429,4.429,0,0,1,193,16.464V4.536A4.429,4.429,0,0,1,197.313,0h11.34a4.429,4.429,0,0,1,4.313,4.536V16.464A4.429,4.429,0,0,1,208.653,21",
    transform: "translate(-193 0)",
    fill: "#2e6db5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_12640",
    "data-name": "\\uD328\\uC2A4 12640",
    d: "M233.56,20.655h1.532v-2.7a19.161,19.161,0,0,0-2.622-.215c-2.675,0-4.424,1.521-4.424,4.275v2.412H225v3.23h3.047v7.9h3.618v-7.9h2.763l.526-3.23h-3.289V22.367c0-.867.451-1.712,1.9-1.712",
    transform: "translate(-219.985 -14.549)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.aa3737ca4e7c4baf4981b40e0cdcff16.svg";
export { ForwardRef as ReactComponent };